import { Label } from '@fluentui/react-components';
import loc from 'owa-localize';
import { observer } from 'owa-mobx-react';
import { BRANDING_LABEL_ID } from '../../constants/constants';
import { headerBrandName } from '../OwaHeader.locstring.json';
import { brandingLabel } from '../OwaHeader.scss';
import type { FunctionComponent } from 'react';

const defaultExport: FunctionComponent<{}> = observer(function OwaHeaderBrandingLabel() {
    return (
        <Label id={BRANDING_LABEL_ID} className={brandingLabel} size="large" weight="semibold">
            {loc(headerBrandName)}
        </Label>
    );
}, 'OwaHeaderBrandingLabel');
export default defaultExport;
